export const blogContent = {
    "header": " Noticias, Novedades, Artículos.",
    "paragraph": "Una selección de artículos y noticias realizados para nuestros clientes, ayudando a mejorar el producto."
}